import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  type ReactNode,
} from "react";

interface InviteContextType {
  incomingRoomInvite: string | null;
  setIncomingRoomInvite: React.Dispatch<React.SetStateAction<string | null>>;
}

const InviteContext = createContext<InviteContextType | undefined>(undefined);
InviteContext.displayName = "InviteContext";

export const InviteProvider = ({ children }: { children: ReactNode }) => {
  const [incomingRoomInvite, setIncomingRoomInvite] = useState<string | null>(null);

  const value = useMemo<InviteContextType>(
    () => ({
      incomingRoomInvite,
      setIncomingRoomInvite,
    }),
    [incomingRoomInvite]
  );

  return (
    <InviteContext.Provider value={value}>
      {children}
    </InviteContext.Provider>
  );
};

export const useInvite = (): InviteContextType => {
  const context = useContext(InviteContext);
  if (!context) throw new Error("useInvite must be used within InviteProvider");
  return context;
};
